import { render, staticRenderFns } from "./MitmachenJoinTabs.vue?vue&type=template&id=0fded8c8&scoped=true&"
import script from "./MitmachenJoinTabs.vue?vue&type=script&lang=js&"
export * from "./MitmachenJoinTabs.vue?vue&type=script&lang=js&"
import style0 from "./MitmachenJoinTabs.vue?vue&type=style&index=0&id=0fded8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fded8c8",
  null
  
)

export default component.exports